module.exports = __webpack_public_path__ + "static/media/Search.ff8ed2cc.svg";